<template>
  <el-dialog
    :title="'拥有【'+ originData.menuName + '权限】的员工'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="800px"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  roleUserList,
} from 'api/system';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      dialogFormVisible: false,
      originData: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectTar: 'loginAcct',
        chooseRadio: '', // 单选选择
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'linkman',
            label: '登录手机',
          },
          {
            prop: 'loginAcct',
            label: '员工姓名',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: roleUserList,
    show (data) {
      this.dialogFormVisible = true;
      this.originData = data;
      this.saveSearchBoxData({
        entityId: data.entityId,
      });
    },
  },
};
</script>

<style>

</style>
